import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppRouter from './router';

ReactDOM.render(<AppRouter/>, document.getElementById('root'));
